import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { JobService } from 'src/app/services/job.service';
import { AppCoreService } from 'src/app/services/app-core.service';
import { ExcelService } from 'src/app/services/excel.service';

@Component({
  selector: 'app-jobs-error',
  templateUrl: './jobs-error.component.html',
  styleUrls: ['./jobs-error.component.scss']
})
export class JobsErrorComponent {
  @Input() public jobGuid: any;
  data: any;

  dialogTitle: string;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private excelService: ExcelService,
    private ngxLoaderService: NgxUiLoaderService,
    private appCoreService: AppCoreService,
    private jobService: JobService,
  ) { }


  ngOnInit() {
    this.bindJobErrors();
    this.dialogTitle = 'Error Details :'
  }

  bindJobErrors() {
    try {
      this.ngxLoaderService.start();
      this.jobService.GetByGuid(this.jobGuid).subscribe(res => {
        this.ngxLoaderService.stop();
        if (res && res.success) {
          this.data = res.data[0].validationresult?.errors; // Assign the validationresult array
          // console.log("Validation Errors:", this.data);
        } else {
          this.data = []; // Ensure it's an array to prevent template errors
        }
      });
    }
    catch (err) {
      this.ngxLoaderService.stop();
      console.error(err);
    }
  }


}
